module.exports = __webpack_public_path__ + "img/cause4Green.510e6d2a.png";